export const LOCAL_SCALE_PREFERENCE_EVENT = 'pos-local-scale-preference';
const PREFIX = 'pos-local-scale:v1:';
const selectedPorts = new Map();

export const localScaleRegisterKey = ({ companyId, branchId, cashRegisterId }) => (
  [companyId, branchId, cashRegisterId].every(value => value != null && String(value).trim())
    ? [companyId, branchId, cashRegisterId].map(String).join(':') : ''
);
export const localScaleScopeKey = (scope) => {
  const register = localScaleRegisterKey(scope);
  return register && scope.userId && scope.cashRegisterSessionId
    ? `${register}:${scope.cashRegisterSessionId}:${scope.userId}` : '';
};
export const normalizeLocalScalePreference = (value) => ({
  mode: value?.mode === 'local' ? 'local' : 'server',
  baudRate: [2400, 4800, 9600, 19200, 38400, 57600, 115200].includes(Number(value?.baudRate)) ? Number(value.baudRate) : 'auto',
  transmissionMode: value?.transmissionMode === 'stable_non_zero' ? 'stable_non_zero' : 'continuous',
  device: value?.device && typeof value.device === 'object' ? {
    ...(Number.isInteger(value.device.usbVendorId) ? { usbVendorId: value.device.usbVendorId } : {}),
    ...(Number.isInteger(value.device.usbProductId) ? { usbProductId: value.device.usbProductId } : {}),
  } : null,
});
export const readLocalScalePreference = (key) => {
  try { return normalizeLocalScalePreference(JSON.parse(window.localStorage.getItem(PREFIX + key))); }
  catch { return normalizeLocalScalePreference(null); }
};
export const saveLocalScalePreference = (key, value) => {
  if (!key) throw new Error('Selecciona empresa y caja antes de configurar la balanza.');
  const preference = normalizeLocalScalePreference(value);
  // Report persistence failure to the caller; never promise automatic reconnect
  // when the browser refused to save the choice.
  window.localStorage.setItem(PREFIX + key, JSON.stringify(preference));
  window.dispatchEvent(new CustomEvent(LOCAL_SCALE_PREFERENCE_EVENT, { detail: { key } }));
  return preference;
};
export const subscribeLocalScalePreference = (key, callback) => {
  const handle = event => {
    if ((event.type === 'storage' && (event.key === PREFIX + key || event.key === null)) || event.detail?.key === key) callback();
  };
  window.addEventListener('storage', handle);
  window.addEventListener(LOCAL_SCALE_PREFERENCE_EVENT, handle);
  return () => {
    window.removeEventListener('storage', handle);
    window.removeEventListener(LOCAL_SCALE_PREFERENCE_EVENT, handle);
  };
};
export const rememberLocalScalePort = (key, port) => selectedPorts.set(key, port);
export const chooseRememberedScalePort = (key, preference, ports) => {
  const selected = selectedPorts.get(key);
  if (selected && ports.includes(selected)) return selected;
  if (!preference.device) return null;
  const matches = ports.filter(port => {
    const info = port.getInfo();
    return ['usbVendorId', 'usbProductId'].every(field => info[field] === preference.device[field]);
  });
  // Web Serial does not expose a persistent serial number. Never guess between
  // two indistinguishable authorized adapters after a page/browser reload.
  return matches.length === 1 ? matches[0] : null;
};
